import {publicationsActions} from '../actions';
import * as Helpers from '../helpers/generalHelpers';
import * as Date from '../elements/dates/dateHelpers';

export default function publications(initialState = {}, action) {
    const newState = {...initialState};
    switch (action.type) {
        case publicationsActions.SET_PUBLICATIONS: return setPublicationsReducer(newState, action);
        case publicationsActions.GENERAL_PUBLICATIONS_REQUEST:return setPublicationsReducer(newState, action);
        case publicationsActions.GENERAL_PUBLICATIONS_SUCCESS: return createAndEditReducer(newState, action);
        case publicationsActions.DELETE_PUBLICATIONS_SUCCESS: return deleteReducer(newState, action);
        case publicationsActions.GENERAL_PUBLICATIONS_ERROR: return setPublicationsReducer(newState, action);
        default: return newState;
    }
}

function setPublicationsReducer(newState, action) {
    delete action.type;
    newState = Object.assign(newState, {...action});
    return newState;
}

function createAndEditReducer(newState, action) {
    delete action.type;
    delete action.body.type;

    const itemIndex = newState.body.find( item => item.id === action.body.id );

    if ( !itemIndex ) {
        newState.body.push( action.body )
    } else {
        newState.body[ newState.body.indexOf( itemIndex ) ] = action.body;
    }

    let arrCopy = [...newState.body], orderedArr = Date.orderByDate( arrCopy );

    newState.body = [...orderedArr];

    return newState;
}

function deleteReducer(newState, action) {
    delete action.type;
    newState.body = newState.body.filter(e => e.id !== action.body);
    return newState;
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/publications.js